import { createReducer, on } from '@ngrx/store';
import { ApiClientSettingApiActions, ApiClientSettingViewActions } from './api-client-setting.actions';
import { initialState, adapter, selectIdFromSetting } from './api-client-setting.state';

export const apiClientSettingReducer = createReducer(
  initialState,
  on(ApiClientSettingApiActions.settingsLoaded, (state, { settings }) => adapter.upsertMany(settings, state)),
  on(ApiClientSettingApiActions.settingAdded, (state, { setting }) =>
    adapter.mapOne(
      {
        id: '',
        map: () => ({
          ...setting,
        }),
      },
      state
    )
  ),
  on(
    ApiClientSettingApiActions.settingUpdated,
    ApiClientSettingApiActions.settingUpdatedError,
    ApiClientSettingApiActions.settingDeletedError,
    ApiClientSettingViewActions.settingAdded,
    (state, { setting }) => adapter.upsertOne(setting, state)
  ),
  on(ApiClientSettingViewActions.settingUpdated, (state, { originalSetting, setting }) =>
    adapter.upsertOne(
      {
        id: originalSetting.id,
        displayName: originalSetting.displayName,
        humanId: originalSetting.humanId,
        credentials: setting,
      },
      state
    )
  ),
  on(ApiClientSettingApiActions.settingAddedError, ApiClientSettingViewActions.settingDeleted, (state, { setting }) =>
    adapter.removeOne(selectIdFromSetting(setting), state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectApiClientSettingIds = selectIds;
export const selectApiClientSettingEntities = selectEntities;
export const selectAllApiClientSettings = selectAll;
